import React from 'react'
import { Store } from './store'
import * as PropTypes from 'prop-types'

export const StoreContext = React.createContext(null)
export const store = new Store()

export const StoreProvider = ({ children }) => {
  return (
    <StoreContext.Provider value={store}>
      {children}
    </StoreContext.Provider>
  )
}

StoreProvider.propTypes = {
  children: PropTypes.node.isRequired
}
